export const rentabilityConfigurationList = {
  message: 'OK',
  data: {
    results: [
      {
        id: '1',
        month: '2025-01',
        percentage: 15.5,
        isActive: true
      },
      {
        id: '2',
        month: '2025-02',
        percentage: 18.0,
        isActive: true
      },
      {
        id: '3',
        month: '2025-03',
        percentage: 12.5,
        isActive: false
      }
    ],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      limit: 20,
      end: 1,
      range: [1],
      count: 3,
      pages: 1,
      total: 3
    }
  }
}
